import React, {useEffect, useState} from "react";
import PropTypes from 'prop-types';
import {compose} from "recompose";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import FiltersBar from "../../Filters/FiltersBar";
import Filter from "../../Filters/Filter";
import t from "../../../languages/pl";
import ActionCreator from './../../../store/actions/index';
import Button from "@material-ui/core/Button";
import {withStyles} from "@material-ui/core";
import BuildIcon from '@material-ui/icons/Build';
import {TooltipTop as CustomTooltip} from './../../Common/CustomTooltips';
import {CSVLink} from "react-csv";
import AssignmentIcon from '@material-ui/icons/Assignment';


const csvHeaders = [
    {label: "Rejestracja", key: "rejestracja"},
    {label: "Marka", key: "marka"},
    {label: "Model", key: "model"},
    {label: "Opis", key: "opis"},
    {label: "ECO", key: "eco"},
    {label: "Stan paliwa", key: "stan_paliwa"},
    {label: "Stan licznika", key: "dystans"},
    {label: "Grupy", key: "nazwyGrup"},
];

const CarsTopBar = props => {
    const {inServiceFilter, searchField, classes, data} = props;
    const [updatedData, setUpdatedData] = useState([]);
    useEffect(() => {
        props.setSearchField("");
    }, []);

    useEffect(() => {
        if (data.length > 0) {
            data.forEach((part, index, array) => {
                array[index].eco = array[index].eco.toString().replace('.', ',');
                const groupNames = array[index].grupy.map(g => g.grupa);
                array[index].nazwyGrup = groupNames.join(', ');
            });

            setUpdatedData(data);
        } else {
            setUpdatedData([]);
        }
    }, [data]);

    const handleSearch = (description = searchField, address) => {
        console.log('Car Top Bar handleSearch', description, address);
        props.getCarsDetails(description, address);
    };

    return (
        <FiltersBar>
            <div className={classes.filterElement}>
            </div>
            <div className={classes.filterElement}>
                <Filter
                    onSearching={handleSearch}
                    disableSelect
                >
                    <CustomTooltip title={t.inServiceTooltip}>
                        <Button
                            style={{minWidth: 30}}
                            onClick={() => props.changeInServiceFilter()}
                        >
                            <BuildIcon style={{color: inServiceFilter ? "inherit" : "#b7b5b5"}}/>
                        </Button>
                    </CustomTooltip>
                </Filter>
            </div>
            <div className={classes.filterElement}>
                <div className={classes.buttonSpace}>
                    <Button
                        variant="contained"
                        color="secondary"
                        className={classes.button}
                    >
                        <div className={classes.icon}>
                            <AssignmentIcon/>
                        </div>
                        <CSVLink
                            headers={csvHeaders}
                            data={updatedData}
                            filename={t.carsExportFilename}
                            target="_blank"
                            className={classes.exportToFile}
                            separator=";"
                        >
                            {t.exportToFile}
                        </CSVLink>
                    </Button>
                </div>
            </div>
        </FiltersBar>
    );
};


const useStyles = theme => ({
    filterElement: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start'
    },
    exportToFile: {
        textDecoration: "none",
        color: theme.palette.common.white
    },
    button: {
        maxHeight: theme.spacing(4.5),
    },
    buttonSpace: {
        paddingLeft: theme.spacing(5),
    },
    icon: {
        paddingTop: theme.spacing(0.7),
        paddingRight: theme.spacing(1),
    }
});

const mapStateToProps = (state) => ({
    searchField: state.filterReducer.searchField,
    inServiceFilter: state.filterReducer.inService
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActionCreator, dispatch);
};


export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps
    ),
    withStyles(useStyles),
    withRouter
)(CarsTopBar);

CarsTopBar.propTypes = {
    classes: PropTypes.object,
    data: PropTypes.array,
    //router
    history: PropTypes.object,
    //redux
    searchField: PropTypes.string,
    inServiceFilter: PropTypes.bool,
    changeInServiceFilter: PropTypes.func,
    getCarsDetails: PropTypes.func,
    setSearchField: PropTypes.func,
};